<div class="password-and-user-logout-policy" data-automation-id="password-and-user-logout-policy-container">
    <div class="header-bar top" data-automation-id="password-and-user-logout-policy-header">
        <button type="button" data-automation-id="password-and-user-logout-policy-save-button" class="primary-button"
            *ngIf="hasCreatePermissions" (click)="saveChanges()" [disabled]="!isDirty || isSaveDisabled()">Save</button>
        <button type="button" data-automation-id="password-and-user-logout-policy-discard-changes-button"
            *ngIf="hasCreatePermissions" class="secondary-button" (click)="discardChanges()"
            [disabled]="isDiscardDisabled()">Discard
            Changes</button>
        <button type="button" class="help-button" data-automation-id="password-and-user-logout-policy-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="password-and-user-logout-policy-content"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="settings-panel-header">Password Policy</div>

        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label data-automation-id="password-and-user-logout-policy-password-expires-label">Password
                    expires</label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="1" [maxLength]="passwordInputSize"
                    [disabled]="!hasCreatePermissions || isTPAuthEnabled"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('passwordExpirationInDays');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : this.value.length == 0 ? event.charCode > 48 && event.charCode <= 57 : event.charCode >= 48 && event.charCode <= 57"
                    name="passwordExpirationInDays" class="input-box" id="passExpDays"
                    [(ngModel)]="viewModel.model.passwordExpirationInDays"
                    [value]="viewModel.model.passwordExpirationInDays" (blur)="parseNumeric('passwordExpirationInDays')"
                    data-automation-id="password-and-user-logout-policy-password-expires-input"
                    (ngModelChange)="onChange()" [(resScrollablePopover)]="errors.passwordExpirationInDays"
                    [popoverErrorMessage]="errorMessage" popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-password-expires-error-message'">
            </div>
            <label data-automation-id="password-and-user-logout-policy-password-expires-label">days since
                change/reset</label>
        </div>

        <div class="modal-row">
            <div class="modal-row-column-auto" *ngIf="isTPAuthEnabled">
                <label data-automation-id="password-and-user-logout-policy-password-history-length-label">The
                    last</label>
            </div>
            <div class="modal-row-column-auto">
                <res-custom-checkbox name="enforceStrongPasswords" [disabled]="!hasCreatePermissions"
                    *ngIf="!isTPAuthEnabled" automationId="password-and-user-logout-policy-strong-password"
                    [(ngModel)]="viewModel.model.enforceStrongPasswords"
                    content="Enable the password strength rules below" (ngModelChange)="onChange()">
                </res-custom-checkbox>
                <input type="number" disabled class="input-box" id="historyLength" *ngIf="isTPAuthEnabled"
                    [value]="viewModel.model.historyLength"
                    data-automation-id="password-and-user-logout-policy-password-history-length-input" />
            </div>
            <label data-automation-id="password-and-user-logout-policy-password-history-length-label"
                *ngIf="isTPAuthEnabled">passwords can't be used</label>
        </div>

        <div class="modal-row">
            <div class="text-box">
                <label data-automation-id="password-and-user-logout-policyminimum-password-length-label">
                    Minimum password length:</label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" [maxLength]="inputSize"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('minimumPasswordLength');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="minimumPasswordLength" class="input-box" [(ngModel)]="viewModel.model.minimumPasswordLength"
                    [value]="viewModel.model.minimumPasswordLength" (blur)="parseNumeric('minimumPasswordLength')"
                    data-automation-id="password-and-user-logout-policy-minimum-password-length-input"
                    (ngModelChange)="onChange()"
                    [disabled]="!viewModel.model.enforceStrongPasswords || !hasCreatePermissions" id="passLength"
                    [(resScrollablePopover)]="errors.minimumPasswordLength" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-minimum-password-length-error-message'">
            </div>
            <div class="modal-row-column-auto">
                <label
                    data-automation-id="password-and-user-logout-policy-minimum-password-length-chars-label">characters</label>
            </div>
        </div>

        <div class="modal-row">
            <div class="text-box">
                <label data-automation-id="password-and-user-logout-policy-minimum-uppercase-letters-label">
                    Minimum uppercase letters:</label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" [maxLength]="inputSize"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('minimumUppercaseLetters');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="minimumUppercaseLetters" class="input-box"
                    [(ngModel)]="viewModel.model.minimumUppercaseLetters"
                    (blur)="parseNumeric('minimumUppercaseLetters')" [value]="viewModel.model.minimumUppercaseLetters"
                    data-automation-id="password-and-user-logout-policy-minimum-uppercase-letters-input"
                    (ngModelChange)="onChange()"
                    [disabled]="!viewModel.model.enforceStrongPasswords || !hasCreatePermissions"
                    [(resScrollablePopover)]="errors.minimumUppercaseLetters" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-minimum-uppercase-letters-error-message'">
            </div>
        </div>

        <div class="modal-row">
            <div class="text-box">
                <label data-automation-id="password-and-user-logout-policy-minimum-lowercase-letters-label">Minimum
                    lowercase
                    letters:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" [maxLength]="inputSize"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('minimumLowercaseLetters');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="minimumLowercaseLetters" class="input-box"
                    [(ngModel)]="viewModel.model.minimumLowercaseLetters"
                    [value]="viewModel.model.minimumLowercaseLetters" (blur)="parseNumeric('minimumLowercaseLetters')"
                    data-automation-id="password-and-user-logout-policy-minimum-lowercase-letters-input"
                    (ngModelChange)="onChange()"
                    [disabled]="!viewModel.model.enforceStrongPasswords || !hasCreatePermissions"
                    [(resScrollablePopover)]="errors.minimumLowercaseLetters" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-minimum-lowercase-letters-error-message'">
            </div>
        </div>

        <div class="modal-row">
            <div class="text-box">
                <label data-automation-id="password-and-user-logout-policy-minimum-numbers-label">Minimum
                    numbers:</label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" [maxLength]="inputSize"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('minimumNumbers');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="minimumNumbers" class="input-box" [(ngModel)]="viewModel.model.minimumNumbers"
                    [value]="viewModel.model.minimumNumbers" (blur)="parseNumeric('minimumNumbers')"
                    data-automation-id="password-and-user-logout-policy-minimum-numbers-input"
                    (ngModelChange)="onChange()"
                    [disabled]="!viewModel.model.enforceStrongPasswords || !hasCreatePermissions"
                    [(resScrollablePopover)]="errors.minimumNumbers" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-minimum-numbers-error-message'">
            </div>
        </div>

        <div class="modal-row bottom-margin">
            <div class="text-box">
                <label data-automation-id="password-and-user-logout-policy-minimum-symbols-label">
                    Minimum symbols:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" [maxLength]="inputSize"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('minimumSymbols');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="minimumSymbols" class="input-box" [(ngModel)]="viewModel.model.minimumSymbols"
                    [value]="viewModel.model.minimumSymbols" (blur)="parseNumeric('minimumSymbols')"
                    data-automation-id="password-and-user-logout-policy-minimum-symbols-input"
                    (ngModelChange)="onChange()"
                    [disabled]="!viewModel.model.enforceStrongPasswords || !hasCreatePermissions"
                    [(resScrollablePopover)]="errors.minimumSymbols" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom"
                    [popoverAutomationId]="'password-and-user-logout-policy-minimum-symbols-error-message'">
            </div>
            <label data-automation-id="password-and-user-logout-policy-minimum-symbols-example-label" class="example">
                For example: ! &#64; # $ %</label>
        </div>

        <div class="settings-panel-header top-border">User Session Settings</div>

        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label data-automation-id="user-session-settings-log-out-label">
                    Log user out after</label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="1" [maxLength]="inputSize" [disabled]="!hasCreatePermissions"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    (input)="validateInputOnPaste('inactivityTimeoutInSeconds');"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : this.value.length == 0 ? event.charCode > 48 && event.charCode <= 57 : event.charCode >= 48 && event.charCode <= 57"
                    name="inactivityTimeoutInSeconds" class="input-box"
                    [(ngModel)]="viewModel.model.inactivityTimeoutInSeconds"
                    [value]="viewModel.model.inactivityTimeoutInSeconds"
                    data-automation-id="user-session-settings-log-out-inactivity-input" (ngModelChange)="onChange()"
                    [(resScrollablePopover)]="errors.inactivityTimeoutInSeconds" [popoverErrorMessage]="errorMessage"
                    popoverType="info" popoverPlacement="bottom" (blur)="parseNumeric('inactivityTimeoutInSeconds')"
                    [popoverAutomationId]="'user-session-settings-log-out-inactivity-error-message'">
            </div>
            <div class="modal-row-column-auto">
                <label data-automation-id="user-session-settings-log-out-minutes-inactivity-label">minutes of
                    inactivity</label>
            </div>
        </div>

    </form>
</div>